import { GetterTree } from "vuex";
import { PointState } from "../types/PointState";
import { RootState } from "@service/store/types/RootState";

const getters: GetterTree<PointState, RootState> = {
    points: (state) => {
        return state.points
    },
};

export {getters}